export default __webpack_public_path__ + "static/media/banner4.a49af77c.svg";